import React, { type ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";

import type { Theme } from "src/theme";
import { StatefulLoadableIconButton } from "src/components/LoadableIconButton";

const useStyles = makeStyles((theme: Theme) => {
  const { derived } = theme.palette.custom;

  return {
    wrapper: {
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
    },
    title: {
      gridColumn: 2,
      textAlign: "center",
      color: derived.accentOnCard,
      margin: 0,
    },
    right: {
      gridColumn: 3,
      justifySelf: "end",
    },
  };
});

export interface DownloadButtonProps {
  onClick: () => Promise<void>;
  disabled?: boolean;
}

export function DownloadButton({ onClick, disabled }: DownloadButtonProps) {
  return (
    <StatefulLoadableIconButton onClick={onClick} disabled={disabled}>
      <GetAppIcon />
    </StatefulLoadableIconButton>
  );
}

interface TitleProps {
  children?: ReactNode | null;
  actions?: ReactNode | undefined | null;
}

function Title({ children, actions }: TitleProps) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.title}>{children}</h2>
      {actions ? (
        <div className={classes.right} data-html2canvas-ignore>
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export default Title;
